import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchRfidOnRouteNonConsolidatedReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRfidOnRouteNonConsolidatedReport',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      endDate: moment(payload.params.endDate).format('YYYY-MM-DD'),
      rfid: payload.params.rfid,
      startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchRfidOnRouteNonConsolidatedReport;
